import React from "react";
import { Routes, Route } from "react-router-dom";

import FontLayout from "../Font/components/FontLayout";

import Home from "../Font/pages/Home";
import ProductGroup from "../Font/pages/ProductGroup";
import AllProducts from "../Font/pages/AllProducts";
import ShopByBrand from "../Font/pages/ShopByBrand";
import AboutUs from "../Font/pages/AboutUs";
import Contact from "../Font/pages/Contact";
import CollectionDetails from "../Font/pages/CollectionDetails";
import ProductDetails from "../Font/pages/ProductDetails";
import FeaturedProducts from "../Font/pages/FeaturedProducts";
import FeaturedProductDetails from "../Font/pages/FeaturedProductDetails";
import BestSellers from "../Font/pages/BestSellerPage";
import TrendingPage from "../Font/pages/TrendingPage";
import Checkout from "../Font/pages/Checkout";
import LoginSignup from "../Font/pages/LoginSignup";
import TermsOfService from "../Font/pages/TermsOfService";
import PrivacyPolicy from "../Font/pages/PrivacyPolicy";
import WarrantyPolicy from "../Font/pages/WarrantyPolicy";
import ReturnPolicy from "../Font/pages/ReturnPolicy";
import SearchPage from "../Font/pages/SearchPage";
import PayoutPage from "../Font/pages/PayoutPage";
import ShopByBrandProductDetails from "../Font/components/ShopByBrandProductDetails";

/* ── NEW GENERIC CATEGORY PAGES ── */
import CategoryPage from "../Font/pages/CategoryPage";
import CategoryDetails from "../Font/pages/CategoryDetails";

import NotFound from "../Font/pages/NotFound";
/* DASHBOARD */
import ProtectedRoute from "./ProtectedRoute";
import DashboardLayout from "../Font/pages/Dashboard/DashboardLayout";
import Profile from "../Font/pages/Dashboard/Profile";
import OrderHistory from "../Font/pages/Dashboard/OrderHistory";
import OrderDetails from "../Font/pages/Dashboard/OrderDetails";
import Settings from "../Font/pages/Dashboard/Settings";

const FontRoutes = () => {
  return (
    <Routes>
      
      <Route element={<FontLayout />}>
        {/* HOME */}
        <Route index element={<Home />} />

        {/* PRODUCT GROUP */}
        <Route path="product-group" element={<ProductGroup />} />
        <Route path="product-group/:product" element={<ProductGroup />} />

        {/* ALL PRODUCTS */}
        <Route path="products" element={<AllProducts />} />

        {/* SHOP BY BRAND */}
        <Route path="shop-by-brand" element={<ShopByBrand />} />
        <Route path="shop-by-brand/:brand" element={<ShopByBrand />} />
        <Route path="shop-by-brand/product/:id" element={<ShopByBrandProductDetails />} />

        {/* ABOUT */}
        <Route path="about-us" element={<AboutUs />} />

        {/* CONTACT */}
        <Route path="contact" element={<Contact />} />

        {/* COLLECTION */}
        <Route path="collection-details" element={<CollectionDetails />} />

        {/* PRODUCT DETAILS */}
        <Route path="product/:id" element={<ProductDetails />} />

        {/* FEATURED */}
        <Route path="featured-products" element={<FeaturedProducts />} />
        <Route path="featured-product-details" element={<FeaturedProductDetails />} />

        {/* BEST SELLERS */}
        <Route path="best-sellers" element={<BestSellers />} />

        {/* TRENDING */}
        <Route path="trending" element={<TrendingPage />} />

        {/* CHECKOUT */}
        <Route path="checkout" element={<Checkout />} />

        {/* PAYOUT */}
        <Route
          path="payout"
          element={
            <ProtectedRoute>
              <PayoutPage />
            </ProtectedRoute>
          }
        />

        {/* ════════════════════════════════════════════════════
            GENERIC DYNAMIC CATEGORY ROUTES  (replaces 18 files)
            URL pattern: /category/:slug  and /category/:slug/:productId
        ════════════════════════════════════════════════════ */}
        <Route path="category/:slug" element={<CategoryPage />} />
        <Route path="category/:slug/:productId" element={<CategoryDetails />} />

        {/* LOGIN */}
        <Route path="login" element={<LoginSignup />} />

        {/* LEGAL */}
        <Route path="terms" element={<TermsOfService />} />
        <Route path="privacy-policy" element={<PrivacyPolicy />} />
        <Route path="warranty-policy" element={<WarrantyPolicy />} />
        <Route path="return-policy" element={<ReturnPolicy />} />

        {/* SEARCH */}
        <Route path="search" element={<SearchPage />} />

        {/* DASHBOARD */}
        <Route
          path="dashboard"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Profile />} />
          <Route path="profile" element={<Profile />} />
          <Route path="orders" element={<OrderHistory />} />
          <Route path="orders/:id" element={<OrderDetails />} />
          <Route path="settings" element={<Settings />} />
        </Route>

      </Route>
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default FontRoutes;